import { useCallback } from 'react';

import { useMainActions } from '../../store/main';

interface SelectChangeEvent {
  target: { value: string };
}

interface Handlers {
  handleCustomerChange: (event: SelectChangeEvent) => void;
  handleWorkspaceChange: (event: SelectChangeEvent) => void;
}

export const useHandlers = (): Handlers => {
  const mainActions = useMainActions();

  const handleCustomerChange = useCallback(
    ({ target }: SelectChangeEvent) => mainActions.selectCustomer(target.value),
    [mainActions]
  );

  const handleWorkspaceChange = useCallback(
    ({ target }: SelectChangeEvent) => mainActions.selectWorkspace(target.value),
    [mainActions]
  );

  return { handleCustomerChange, handleWorkspaceChange };
};
